import { createParser, useQueryState } from 'nuqs';
import React, { useTransition } from 'react';

import { DriveTypeList } from '@/services/filters/new-filters.service';

import { isFilterEqual, useClearSearch, useResetPage } from '../../utils';
import { FilterBlockGroup } from '../common/filter-block-group';

export const NewDriveTypeFilter: React.FC<{
  driveTypes: DriveTypeList;
}> = ({ driveTypes }) => {
  const [_, startTransition] = useTransition();

  const [queryDriveTypes, setQueryDriveTypes] = useQueryState(
    'drivetype',
    createParser({
      parse: (value) => {
        const selectedIds = value ? value.split(',').map(Number) : [];

        return (
          driveTypes?.map((type) => ({
            ...type,
            isSelected: selectedIds.includes(type.id),
          })) || []
        );
      },
      serialize: (value) => {
        return value
          .filter((item) => item.isSelected)
          .map((item) => item.id)
          .join(',');
      },
      eq(a, b) {
        return isFilterEqual(a, b);
      },
    })
      .withDefault(
        driveTypes?.map((type) => ({ ...type, isSelected: false })) || [],
      )
      .withOptions({
        startTransition,
        shallow: false,
        history: 'replace',
      }),
  );

  const clearSearch = useClearSearch();
  const resetPage = useResetPage();

  const handleSelect = (filter: (typeof queryDriveTypes)[number]) => {
    clearSearch();
    
    // Reset page to 1 when drive type filters change
    resetPage();

    setQueryDriveTypes(
      queryDriveTypes.map((item) =>
        item.id === filter.id
          ? { ...item, isSelected: !item.isSelected }
          : item,
      ),
    );
  };

  return (
    <FilterBlockGroup
      label="Drive Type"
      filters={queryDriveTypes}
      onSelect={handleSelect}
    />
  );
};
